import { useState } from 'react';
import { Link } from 'react-router-dom';
import { trendingMovies } from '@/mocks/home';

const CATEGORY_LABELS: Record<string, string> = {
  movie: '电影',
  tv: '电视剧',
  anime: '动漫',
  variety: '综艺',
};

export default function TrendingSection() {
  const [activeFilter, setActiveFilter] = useState<string>('all');

  const filtered =
    activeFilter === 'all'
      ? trendingMovies
      : trendingMovies.filter((m) => m.category === activeFilter);

  const displayMovies = filtered.slice(0, 8);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 lg:px-8">
      <div className="max-w-[1440px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <div className="w-1 h-5 rounded-full bg-primary-500"></div>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
                热门推荐
              </h2>
            </div>
            <p className="text-sm text-foreground-500">
              精选热门影视内容，大家都在看
            </p>
          </div>
          <div className="flex items-center gap-1.5 bg-background-100 rounded-full p-1">
            {[
              { key: 'all', label: '全部' },
              { key: 'movie', label: '电影' },
              { key: 'tv', label: '电视剧' },
              { key: 'anime', label: '动漫' },
              { key: 'variety', label: '综艺' },
            ].map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveFilter(tab.key)}
                className={`px-4 py-1.5 text-xs font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  activeFilter === tab.key
                    ? 'bg-primary-500 text-white'
                    : 'text-foreground-400 hover:text-foreground-200'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
          {displayMovies.map((movie, index) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group relative block cursor-pointer"
            >
              <div className="relative aspect-[2/3] rounded-lg overflow-hidden bg-background-100">
                <img
                  src={movie.poster}
                  alt={`${movie.title} 海报`}
                  title={`${movie.title} - 91影视热门推荐`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  loading={index < 4 ? undefined : 'lazy'}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 rounded-md bg-primary-500 text-white text-xs font-medium">
                    {movie.rating}
                  </span>
                </div>

                {movie.isHot && (
                  <div className="absolute top-2 right-2">
                    <span className="px-2 py-0.5 rounded-md bg-accent-500 text-black text-xs font-bold">
                      HOT
                    </span>
                  </div>
                )}

                <div className="absolute bottom-0 left-0 right-0 p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <p className="text-xs text-foreground-300 line-clamp-2 mb-2">{movie.description}</p>
                  <div className="flex items-center gap-2">
                    <span className="text-xs text-foreground-400">{CATEGORY_LABELS[movie.category]}</span>
                    <span className="text-xs text-foreground-600">·</span>
                    <span className="text-xs text-foreground-400">{movie.year}</span>
                    <span className="text-xs text-foreground-600">·</span>
                    <span className="text-xs text-foreground-400">{movie.genre}</span>
                  </div>
                </div>
              </div>

              <div className="mt-2.5">
                <h3 className="text-sm font-medium text-foreground-100 group-hover:text-primary-400 transition-colors line-clamp-1">
                  {movie.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{movie.englishTitle}</p>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/category/movie"
            className="inline-flex items-center gap-1.5 px-6 py-2.5 rounded-lg bg-background-100 hover:bg-background-200 text-sm font-medium text-foreground-300 hover:text-foreground-100 transition-all duration-200 cursor-pointer"
          >
            查看更多
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}